<template>
	<div>
		<div v-if="isSending" class="message_sending">
			<div class="loader"></div>Nachricht wird gesendet...
		</div>
		<form enctype="multipart/form-data" v-if="!isSending">
			<div id="chat-sendmessage">
				<textarea
					v-bind:rows="(windowwidth > 1000 ? '3' : '1')"
					placeholder="Gib eine Nachricht ein..."
					@keydown="typing"
					v-model="content"
					v-html="settext"
					autofocus
				></textarea>
				<div id="chat-textarea-buttons">
					<div class="icon icon-streamline-icon-attachment18x18" @click="openAttachmentUpload"></div>
					<span v-if="attachmentCount > 0" class="badge badge-pill badge-info">{{ attachmentCount }}</span>
					<div class="icon icon-streamline-icon-smiley-happy-alternate18x18" @click="toggleEmojiPicker"></div>
					<div class="icon icon-streamline-icon-send-email18x18" @click="sendMessage"></div>
				</div>
				<VEmojiPicker v-clickaway="closeEmojiPicker" v-if="showEmojiPicker" :pack="pack" @select="selectEmoji"/>
				<input
					type="file"
					name="attachment"
					accept="image/*, video/mp4, video/x-m4v, video/*"
					style="display: none;"
					ref="attachmentUpload"
					@change="filesChanged"
				>
			</div>
			<div id="chat-textarea-priceinfo">
				<a id="chat-textarea-paymentlink" href="#payment" @click="lpcms.payment.dialog();" v-if="parseInt(price) > 0">
					Jetzt Guthaben aufladen und kostenlos schreiben
				</a>
				<div>
					Preis: {{ price }}
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import Event from "../event.js";
import VEmojiPicker from "v-emoji-picker";
import packData from "v-emoji-picker/data/emojis.json";

export default {
	props: ["settext", "price"],
	components: {
		VEmojiPicker
	},
	data() {
		return {
			content: this.settext,
			isSending: false,
			attachmentCount: 0,
			pack: packData.data,
			showEmojiPicker: false,
			windowwidth: $(window).width()
		};
	},
	mounted() {
		this.autogrow();
	},
	created() {
		window.addEventListener("resize", this.windowresized);
	},
	destroyed() {
		window.removeEventListener("resize", this.windowresized);
	},
	methods: {
		autogrow() {
			if (this.windowwidth > 1000) {
				jQuery('#chat-sendmessage textarea').focus().autogrow(40,165);
			} else {
				jQuery('#chat-sendmessage textarea').focus().autogrow(20,90);
			}
		},
		windowresized(e) {
			this.windowwidth = $(window).width();
			this.autogrow();
		},
		typing(e) {
			if (e.keyCode === 13 && e.shiftKey) {
				e.preventDefault();
				this.sendMessage();
			}
		},
		toggleEmojiPicker() {
			this.showEmojiPicker = !this.showEmojiPicker;
		},
		closeEmojiPicker(outside) {
			this.showEmojiPicker = false;
		},
		selectEmoji(emoji) {
			this.showEmojiPicker = false;
			var cursorPos = jQuery('textarea', this.$el).prop('selectionStart');
			if (!this.content) {
				this.content = emoji.emoji;
				return true;
			}
			var textBefore = this.content.substring(0,  cursorPos);
			var textAfter  = this.content.substring(cursorPos, this.content.length);

			this.content = textBefore + emoji.emoji + textAfter;
		},
		filesChanged() {
			this.attachmentCount = !this.$refs.attachmentUpload
				? 0
				: this.$refs.attachmentUpload.files.length;
		},
		openAttachmentUpload() {
			this.$refs.attachmentUpload.click();
		},
		sendMessage() {
			if (
				(!this.content || this.content.trim() === "") &&
				this.$refs.attachmentUpload.files.length <= 0
			) {
				return;
			}
			if (this.$refs.attachmentUpload.files.length > 0) {
				this.isSending = true;
			}
			/*var d = new Date();
				Event.$emit("added_message", {
					content: this.content.trim(),
					to: "1",
					from: window.Laravel.user.id,
					created_at:
						("0" + d.getHours()).slice(-2) +
						":" +
						("0" + d.getMinutes()).slice(-2)
				});*/

			let formData = new FormData();
			if (this.content) {
				formData.append("content", this.content.trim());
			}
			formData.append("to", "1");
			for (var i = 0; i < this.$refs.attachmentUpload.files.length; i++) {
				formData.append(
					"attachments[]",
					this.$refs.attachmentUpload.files[i]
				);
			}
			axios
				.post("/chat/sendMessage", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.catch((err) => {
					if (err && err.response && err.response.status) {
						if (err.response.status == 402) {
							lpcms.payment.dialog('Du hast nicht genügend Guthaben. Bitte lade dein Konto auf.');
						}
					}
					this.isSending = false;
				})
				.then(response => {
					if (
						response &&
						response.data &&
						response.data.success &&
						response.data.msg
					) {
						Event.$emit("added_message", response.data.msg);
					}
					this.content = null;
					this.isSending = false;
					this.filesChanged();
				});
		}
	}
};
</script>